module.exports = __webpack_public_path__ + "31802c327ad2d5936d5a12775822fa3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/header-text.png
// module id = 268
// module chunks = 0